import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Slide,
} from '@mui/material';
import { Close, Delete } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  // direction="up" | "down" | "left" | "right"

  return <Slide direction="left" ref={ref} {...props} />;
//  return <Fade ref={ref} {...props} timeout={500} />; // 500ms fade
});

export default function ModalView ({ open, handleClose, title, content, size }) {
  return (
    // 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
    <Dialog open={open} onClose={handleClose} maxWidth={size} fullWidth
     slots={{ transition: Transition }}
      slotProps={{
        transition: {
          timeout: 500,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" >
        <DialogTitle color="#3f2d01" fontWeight={'bold'} >{title}</DialogTitle>
        <IconButton color="error" onClick={handleClose} >
          <Close sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px', color: 'lightgray' }} />
        </IconButton>
      </Box>
      <DialogContent >
        {/* <Typography>{content}</Typography> */}
        {content}
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={handleClose} color="red" variant="contained">
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

// export default ModalView;
